import { isMobile } from "../../helpers";
import { throttle } from "throttle-debounce";

(function ($) {
    const ADMIN_BAR_SELECTOR = '#wpadminbar';
    const BASE_SELECTOR = 'main > aside';
    const HEADER_SELECTOR = 'header.header';

    function pageNav() {
        const isAdmin = !!($(ADMIN_BAR_SELECTOR)?.length > 0);
        const onpageBase = $(BASE_SELECTOR);
        const headerElement = $(HEADER_SELECTOR);

        let topOffset;

        // Calculate and set the onpage nav top offset
        function setOnpageNavOffset() {
            // Calculate header and sub navigation height
            let subsiteNavOffset        = $('.subsite-nav').length ? $('.subsite-nav').outerHeight() : 0;
            let headerOffset            = headerElement.length ? headerElement.outerHeight() : 0;
            let criticalIncidentOffset  = $('#critical-incident-status').length ? $('#critical-incident-status').outerHeight() : 0;

            topOffset = (headerOffset - 1) + subsiteNavOffset + criticalIncidentOffset;
            // Also ensure admin bar height is included
            onpageBase.css({ '--onpage-nav-top-offset': isAdmin ? 'calc(' + topOffset + 'px + var(--wp-admin--admin-bar--height))' : topOffset + 'px' });
        }

        setOnpageNavOffset();

        // Recalculate offsets when page resizes or scrolls (header height changes on scroll)
        $(window).on('resize', throttle(100, () => {
            setOnpageNavOffset();
        }));

        $(window).on('scroll', throttle(50, () => {
            setOnpageNavOffset();
        }));
    }



    // when on mobile 
    $('.onpage-nav__title').on('click', function (e) {
        // use isMobile here to make function works after screen resize
        if (isMobile() == true) {
            $(this).parent().toggleClass('active');
            $(this).siblings('.onpage-nav__list').toggleClass('active');
            $('.onpage-nav__list').find('.active').removeClass('active');
        }
    })

    $('.onpage-nav__item .disable-link').on('click', function (e) {
        $(this).next('.onpage-nav__link-trigger').trigger('click');
    });

    $('.onpage-nav__item .onpage-nav__link-trigger').on('click', function (e) {
        const targetItem = $(this).closest('.onpage-nav__item');

        if (targetItem.hasClass('active')) {
            targetItem.removeClass('active');
            targetItem.find('.active').removeClass('active');

        } else {
            targetItem.toggleClass('active');
            targetItem.find('.onpage-nav__list').first().toggleClass('active');
            targetItem.siblings().removeClass('active');
            targetItem.siblings().find('.active').removeClass('active');
        }
    })


    // if an element in the viewport
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset() !== undefined ? $(this).offset().top : 0;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementTop < viewportBottom;
    };

    // if an element touch footer
    $.fn.isTouchFooter = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight() + 1; // calculate include border height
        var footerTop = $('.footer').offset().top;

        return elementBottom > footerTop;
    };


    $(window).on('load scroll', throttle(100, function () {
        if ($('.footer').isInViewport()) {
            $('.onpage-nav').css({
                '--onpage-sub-nav-height': $('aside').height() + 'px'
            });
        } else {
            $('.onpage-nav').css({
                '--onpage-sub-nav-height': '100vh'
            });
        }
    }));

    $(document).ready(function () {

        if ($('.onpage-nav').length) {
            pageNav();
        }

    });

})(jQuery);
